// JavaScript Document
var $ = jQuery.noConflict();

$(document).ready(function () {
    
    /*
    * pagination ajax data
    */
    $(document).on("click", ".event_pagination_pageno",function() {
       if($.trim(this.className) != 'event_pagination_pageno')
       {
           return false;
       }
       
       /*$('.event_pagination_pageno').removeClass("active");
       $(this).addClass("active");*/
       
       $('.event_pagination_pageno').removeClass("active");
       $('.event_pagination_pageno[data-id='+$(this).attr('data-id')+']').addClass('active');
       
       
       var posts_per_page = $('#posts_per_page').val();
       var page_id = $(this).attr('data-id');
       var search_type = $('#search_type').val();
       
       var search_text = $('#event-search-text').val();
       
       $('#offset').val(0);
       var offset = $('#offset').val();
       
       if((offset == null) || (offset==0))
           offset = 0;

       $.ajax({
           url: ajax_variable,
           type: 'POST',
           dataType: "json",
           data: {
               'action': 'get_load_more_event_pagination',
               'posts_per_page':posts_per_page,
               'offset' : offset,
               'page_id' : page_id,
               'search_text': search_text,
               'search_type' : search_type
           },
           beforeSend: function() {
               $('.loader').show();
           },
           complete: function() {
               $('.loader').hide();
           },
           success: function(r) {
               if (r.response == "success") {
                    $('.blog-post-listing').html(r.message);
                    
                    $("html,body").animate({
                        scrollTop:$(".fertile-select-row").offset().top
                    },1000);
                    if(r.pagination_struc!='')
                    {
                        $('.event-pagination').show();
                        $('.event-pagination').show();
                        $('.event_pagination_wrapper').html(r.pagination_struc);
                    }
                    if(r.pagination_struc==''){
                        $('.event-pagination').hide();
                    }
                   
               } else {
                    $('.blog-post-listing').html('<div class="error-section">'+r.message+'</div>');
                    $('.event-pagination').hide();
               }
           }
       });
    });
    
    /*
     * Text box search
     */
    $("#event-search-text").keyup(function () {
       
        var search_text = $(this).val();
        var posts_per_page = $('#posts_per_page').val();
        
        $('#search_type').val('text');
        $('#offset').val(0);
        var offset = $('#offset').val();

        if((offset == null) || (offset==0))
            offset = 0;

        $.ajax({
            url: ajax_variable,
            type: 'POST',
            dataType: "json",
            data: {
                'action': 'get_event_custom_textbox_search',
                'search_text':search_text,
                'posts_per_page':posts_per_page,
                'offset' : offset,
            },
            beforeSend: function() {
                $('.loader').show();
            },
            complete: function() {
                $('.loader').hide();
            },
            success: function(r) {
                if (r.response == "success") {
                     $('.blog-post-listing').html(r.message);

                     $("html,body").animate({
                         scrollTop:$(".fertile-select-row").offset().top
                     },1000);
                     if(r.pagination_struc!='')
                     {
                         $('.event-pagination').show();
                         $('.event-pagination').show();
                         $('.event_pagination_wrapper').html(r.pagination_struc);
                     }
                     if(r.pagination_struc==''){
                        $('.event-pagination').hide();
                    }

                } else {
                     $('.blog-post-listing').html('<div class="error-section">'+r.message+'</div>');
                     $('.event-pagination').hide();
                }
            }
        });
    });
}); // end of ready funciton